"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));

var defaultState = {
  desktop: {
    url: '',
    error: false
  },
  mobile: {
    url: '',
    error: false
  }
};

var Preview = function Preview() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _AppConstants.default.ActionTypes.FETCH_PREVIEW_STARTED:
      return defaultState;

    case _AppConstants.default.ActionTypes.DESKTOP_WEBSITE_PREVIEWED:
      return (0, _extends2.default)({}, state, {
        desktop: {
          url: action.payload.url
        }
      });

    case _AppConstants.default.ActionTypes.DESKTOP_WEBSITE_PREVIEWED_ERROR:
      return (0, _extends2.default)({}, state, {
        desktop: {
          error: true
        }
      });

    case _AppConstants.default.ActionTypes.MOBILE_WEBSITE_PREVIEWED:
      return (0, _extends2.default)({}, state, {
        mobile: {
          url: action.payload.url
        }
      });

    case _AppConstants.default.ActionTypes.MOBILE_WEBSITE_PREVIEWED_ERROR:
      return (0, _extends2.default)({}, state, {
        mobile: {
          error: true
        }
      });

    default:
      return state;
  }
};

var _default = Preview;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Preview.js
// module id = 320
// module chunks = 0